import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from './AuthContext'; // ✅ Import context
import logo from './icon/logo.png';
import './Home.css';

const Home = () => {
  const history = useHistory();
  const { isAuthenticated, checkAuth } = useAuth(); // ✅ Use context

  useEffect(() => {
    const verifyAuth = async () => {
      await checkAuth(); // Ensure auth state is up to date
    };

    verifyAuth();
  }, [checkAuth]);

  useEffect(() => {
    if (isAuthenticated) {
      history.push('/dashboard');
    }
  }, [isAuthenticated, history]);

  return (
    <div className="home-container">
      <div className="inner-container">
        <div className="text-content">
          <h1 className="hero-title">ONE-STOP APP SHOP</h1>
          <div className="hero-description">
            <p>Download, purchase, and experience premium quality!</p>
            <p>Access all your favorite streaming applications in one convenient location.</p>
          </div>
          <div className="button-group">
            <button 
              className="cta-button primary-cta"
              onClick={() => history.push('/signup')}
            >
              Get Started
            </button>
            <button 
              className="cta-button secondary-cta"
              onClick={() => history.push('/login')}
            >
              Login
            </button>
          </div>
        </div>
        <img 
          src={logo} 
          alt="Logo" 
          className="hero-image" 
        />
      </div>
    </div>
  );
};

export default Home;
